import { z } from "zod";

export const zGameResult = z.enum(["WHITE", "BLACK", "DRAW", "ABORTED"]);

const zPlayerColor = z.enum(["WHITE", "BLACK"]);

export const zGameInput = z.object({
    player1Color: zPlayerColor,
    player2Color: zPlayerColor,
    startedAt: z
        .string()
        .or(z.date())
        .transform(arg => new Date(arg))
        .nullable(),
    scheduledStartAt: z
        .string()
        .or(z.date())
        .transform(arg => new Date(arg)),
    result: zGameResult.nullable(),
    finishedAt: z
        .string()
        .or(z.date())
        .transform(arg => new Date(arg))
        .nullable(),
    heroImageId: z.string().nullable(),
    startingPositionFen: z.string().nullable(),
    pgnRoundTag: z.string().nullable(),
});

export type GameInput = z.infer<typeof zGameInput>;
